// extracted by mini-css-extract-plugin
export default {"container":"Raa-z","oos":"Saa-z","oosUx":"Taa-z","selected":"Uaa-z","labelOos":"Vaa-z"};